export default __webpack_public_path__ + "media/images/theme/bg_dark-4243502ce7a7f3abe9bcb88983e171e7.png";